export const ZALO_CALLBACK = `${process.env.INTEGRATION_BOT_URL}/zalo/receiveChatwootEvent`
export const FACEBOOK_CALLBACK = `${process.env.INTEGRATION_BOT_URL}/facebook/chatwootWebhook`
